import { BASE_SIZE } from '../constant';

export const BASE_INPUT_SIZE = BASE_SIZE;

export enum BASE_INPUT_STATUS {
  ACTIVE = 'active',
  DISABLED = 'disabled',
  ERROR = 'error',
}
